import { ColorTextWhite, ColorCostcoBlue, ColorTextDefault, ColorCostcoRed, ButtonsColorPrimaryText, ColorTextMedium } from "@nxt-costco-com/forge-design-tokens";
const DEFAULT_STRIP_TEXT_COLOR = ColorTextWhite;
const DEFAULT_STRIP_BACKGROUND_COLOR = ColorCostcoRed;
const DEFAULT_HEADER_TILE_BACKGROUND_COLOR = ColorCostcoBlue;
const DEFAULT_HEADER_TITLE_TEXT_COLOR = ColorTextWhite;
const DEFAULT_HEADER_TEXT_ALIGN = "center";
const DEFAULT_TILE_TOP_TEXT_COLOR = ColorTextWhite;
const DEFAULT_TILE_BOTTOM_TEXT_COLOR = ColorTextWhite;
const DEFAULT_BUTTON_TEXT_COLOR = ButtonsColorPrimaryText;
const DEFAULT_BUTTON_BACKGROUND_COLOR = ColorCostcoRed;
const DEFAULT_FEATURE_TILE_TEXT_COLOR = ColorTextDefault;
const DEFAULT_FEATURE_SUBTILE_TEXT_COLOR = ColorTextMedium;
const DEFAULT_FEATURE_TEXT_ALIGN = "left";
const DEFAULT_BADGE_TEXT_COLOR = ColorTextWhite;
const DEFAULT_BADGE_BACKGROUND_COLOR = ColorCostcoBlue;
const DEFAULT_DISCLAIMER_TEXT_COLOR = ColorTextDefault;
export {
  DEFAULT_BADGE_BACKGROUND_COLOR,
  DEFAULT_BADGE_TEXT_COLOR,
  DEFAULT_BUTTON_BACKGROUND_COLOR,
  DEFAULT_BUTTON_TEXT_COLOR,
  DEFAULT_DISCLAIMER_TEXT_COLOR,
  DEFAULT_FEATURE_SUBTILE_TEXT_COLOR,
  DEFAULT_FEATURE_TEXT_ALIGN,
  DEFAULT_FEATURE_TILE_TEXT_COLOR,
  DEFAULT_HEADER_TEXT_ALIGN,
  DEFAULT_HEADER_TILE_BACKGROUND_COLOR,
  DEFAULT_HEADER_TITLE_TEXT_COLOR,
  DEFAULT_STRIP_BACKGROUND_COLOR,
  DEFAULT_STRIP_TEXT_COLOR,
  DEFAULT_TILE_BOTTOM_TEXT_COLOR,
  DEFAULT_TILE_TOP_TEXT_COLOR
};
